enum LoadProviderMode {
  Active = 'active',
  Archive = 'archive',
}

export default LoadProviderMode;
